<ion-textarea rows="2" [formControl]="formControl" [placeholder]="params.placeholder" class="input text-area-style"
	[autoGrow]="params.autoGrow" [autocapitalize]="params.autocapitalize" [debounce]="250" (ionChange)="onModelChanged()">
</ion-textarea>